import ZmanimListEntry from './zmanimListEntry'

export default class ZmanimListHeader extends ZmanimListEntry {
  entryType = 'header';
}
